import type { ButtonHTMLAttributes, HTMLAttributes, PropsWithChildren } from 'react';

export function Button({
  className = '',
  type = 'button',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`sqi-button ${className}`} type={type} {...props} />;
}

export function StatusBadge({
  children,
  tone = 'neutral',
}: PropsWithChildren<{ readonly tone?: string }>) {
  return <span className={`sqi-status sqi-status--${tone}`}>{children}</span>;
}

export function VisuallyHidden({
  children,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLSpanElement>>) {
  return (
    <span className="sqi-visually-hidden" {...props}>
      {children}
    </span>
  );
}
